import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { ApiToUse } from 'app/infrastructure/simple-form/types';
import { groupSelectorFieldName } from './options-panel.utils';
import { GroupingType } from '../types';
import { OptionsPanelDialog } from 'app/components/access-panel/options-panel/options-panel-dialog';
import { ComplexValue } from 'app/types-shared';
import get from 'lodash/get';
import { OptionsPanelState } from 'app/components/access-panel/options-panel/options-panel';
import { ExtraFooterButton } from 'ui/common/select/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

interface OptionPanelComponentProps {
  formName: string;
  groupingName: string;
  valueName: string;
  groupingLabel: string;
  formValues: any;
  addButtonText: string;
  groupingOptionsEndpoint: string;
  formComponent: any;
  addGroup: any;
  valueLabel?: string;
  groupingType?: any;
  useStaticOptions: boolean;
  isDoubleStep?: boolean;
  group?: ComplexValue<number>;
  translation: any;
  displaySelectAll?: boolean;
  levelsNotAllowed?: boolean;
  customState: OptionsPanelState;
  isOptionValues?: boolean;
  valuesOptionsEndpoint: (value: number) => string;
  clearValueInStore?: (contextName: string) => void;
  removeAll?: () => void;
  extraFooterButton?: ExtraFooterButton;
}

class OptionPanelComponent extends React.Component<OptionPanelComponentProps> {

  get groupingName() {
    return groupSelectorFieldName(this.props.formName, this.props.groupingName);
  }

  get valueName() {
    return groupSelectorFieldName(this.props.formName, this.props.valueName);
  }

  public componentDidUpdate(prevProps: OptionPanelComponentProps) {
    if (this.props.useStaticOptions && !this.props.isDoubleStep) {
      const groupingValue = get(this.props.formValues, this.groupingName);
      const prevGroupingValue = get(prevProps.formValues, this.groupingName);
      if ((groupingValue && prevGroupingValue && groupingValue.value !== prevGroupingValue.value)
        || (prevGroupingValue && !groupingValue)) {
        this.props.clearValueInStore && this.props.clearValueInStore(this.valueName);
      }
    }
  }

  public render() {
    const { translation, formValues,
      groupingLabel, groupingOptionsEndpoint, groupingType, group,
      addButtonText, valuesOptionsEndpoint, valueLabel, levelsNotAllowed,
      formComponent: SimpleForm, addGroup, useStaticOptions, displaySelectAll,
      customState: { selectedOptions = [] } = {}, isOptionValues = false, extraFooterButton
    } = this.props;

    const selectedPanel = get(formValues, this.groupingName);
    const selectedPanelValue = selectedPanel && selectedPanel.value;
    const selectedGroupValue = group && group.value;
    const id = selectedGroupValue || selectedPanelValue;
    const showValueFields = (useStaticOptions || selectedGroupValue) && id;

    const groupFieldsInitialValue = isOptionValues
      ? (selectedOptions && selectedOptions)
      : (group && group);

    const valueFieldsInitialValue = this.props.customState && selectedGroupValue
      && this.props.customState.selectedValues[selectedGroupValue];

    const selectedGroupExtraFooterButton = isDefinedIncludingZero(selectedGroupValue) ? extraFooterButton : undefined;

    const groupFields = <SimpleForm
      name={this.groupingName}
      type={groupingType === GroupingType.Single
        ? FIELD_TYPE.SELECT_SINGLE_HIERARCHY : FIELD_TYPE.SELECT_MULTIPLE_HIERARCHY}
      optionsEndpoint={groupingOptionsEndpoint}
      placeholder={translation.search}
      apiToUse={ApiToUse.ADMINAPI}
      translation={translation}
      descriptionAllLevels={true}
      label={{ text: groupingLabel, required: false }}
      initialValue={groupFieldsInitialValue}
      readOnly={!!selectedGroupValue}
      alwaysOpen={true}
      displaySelectAll={groupingType === GroupingType.Multiple ? displaySelectAll : false}
      levelsNotAllowed={levelsNotAllowed}
    />;

    const valueFields = <SimpleForm
      name={this.valueName}
      type={FIELD_TYPE.SELECT_MULTIPLE_HIERARCHY}
      optionsEndpoint={valuesOptionsEndpoint(id)}
      placeholder={translation.search}
      descriptionAllLevels={true}
      apiToUse={ApiToUse.ADMINAPI}
      translation={translation}
      label={{ text: valueLabel, required: false }}
      initialValue={valueFieldsInitialValue}
      alwaysOpen={true}
      displaySelectAll={displaySelectAll}
    />;

    return <OptionsPanelDialog
      onSubmit={addGroup}
      addButtonText={addButtonText}
      doneButtonText={translation.done}
      removeAllText={translation.remove_all_section}
      removeAll={selectedOptions.length > 0 ? this.props.removeAll : undefined}
      extraFooterButton={selectedGroupExtraFooterButton}>
      <div className="col-lg-12">
        <div className={`${!!selectedGroupValue && 'd-none'}`}>
          {groupFields}
        </div>
        {showValueFields && valueFields}
      </div>
    </OptionsPanelDialog>;
  }
}

export const OptionPanel = OptionPanelComponent;
